import { useEffect } from "react";
import { useGetPurchaseOrdersByStatusQuery } from "../../store/api";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { PendingWork } from "../pendingWork/table";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { PendingActions } from "@mui/icons-material";

export const PendingWorkPage = () => {


  const selectedRaffle = useAppSelector(
    ({ selectedRaffle }: RootState) => selectedRaffle,
  );
  
  const { data: purchaseOrders, refetch } = useGetPurchaseOrdersByStatusQuery(
    {
      raffleId: selectedRaffle.id,
      purchaseOrderStatus: "TRANSFER_PAYMENT_CREATED",
    },
    {
      skip: selectedRaffle.id === 'default',
    }
  );

  useEffect(() => {
    if (selectedRaffle.id !== "default") {
      refetch();
    }
  }, [selectedRaffle.id, refetch])
  

  const isMobileView = useIsMobileView();

  return (
    <Box paddingX={isMobileView ? 2 : 10} marginTop={2}>
      <Typography variant="h6" fontFamily={"Georgia"} paddingBottom={2} >
        Trabajo pendiente
      </Typography>
       
        <Card
          variant="outlined"
          sx={{
            borderRadius: 3,
            minHeight: 100,
            paddingY: 2,
            paddingX: 3,
            boxShadow: 1,
            marginY: 2,
            textAlign: 'center',
          }}
        >
          <CardContent sx={{ padding: 0 }}>
            <Typography variant="subtitle2" fontWeight="bold">
              Pendiente validación
            </Typography>

            <Typography variant="h5" fontWeight="bold" color="primary" mt={0.5}>
              {purchaseOrders?.length}
            </Typography>

            <Typography variant="caption">
              Revisa el capture para generar los tickets
            </Typography>
          </CardContent>
        </Card>
      {purchaseOrders ? <PendingWork purchaseOrders={purchaseOrders} selectedRaffle={selectedRaffle} refetch={refetch} hasReferenceNumber={selectedRaffle.hasReferenceNumber} /> : null}
    </Box>
  );
};
